import { GetStaticPaths, GetStaticProps } from "next";

import Docs from "../../components/Docs";

import {
  getDocsPageMarkdown,
  getStaticDocs,
  DocsPageProps,
} from "../../utils/docs";
import { FlashPCBPage } from "../../models/page";
import settings from "../../constants/settings";
import { FlashPCBSettings } from "../../utils/settings";

const DocPage: FlashPCBPage<DocsPageProps> = ({
  title,
  staticDocs,
  markdown,
  flashPCBSettings,
}) => {
  return (
    <Docs
      title={title}
      staticDocs={staticDocs}
      markdown={markdown}
      flashPCBSettings={flashPCBSettings}
    />
  );
};

export const getStaticPaths: GetStaticPaths = () => {
  const { pages } = getStaticDocs();
  // Get the paths we want to pre-render based on posts
  const paths = pages.map((page) => ({
    params: { slug: page.slug },
  }));
  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const response = await fetch(`${settings.api_url}/settings`);
  const flashPCBSettings = (await response.json()) as FlashPCBSettings;

  if (params != undefined) {
    const staticDocs = getStaticDocs();
    const slug = params.slug;
    if (slug == undefined) {
      return {
        props: {
          title: "Documentation",
          staticDocs,
          markdown: getDocsPageMarkdown(staticDocs.pages[0]!.path),
          flashPCBSettings,
        },
        revalidate: 60 * 60 * 24, // daily
      };
    } else if (typeof slug === "string") {
      const page = staticDocs.pages.find((page) => page.slug == slug);
      if (page !== undefined) {
        return {
          props: {
            title: page.title,
            staticDocs,
            markdown: getDocsPageMarkdown(page.path),
            flashPCBSettings,
          },
          revalidate: 60 * 60 * 24, // daily
        };
      }
    }
  }
  return { notFound: true };
};

export default DocPage;
